// Shared preset avatar collection — the illustrated avatars offered on the
// onboarding "Choose Your Avatar" screen (Pages/.../newSign-in/Avatar) and as
// the quick suggestions on Settings → Account. Single source of truth so both
// surfaces always show the same set in the same order.
import avatar01 from 'Assets/01.png';
import avatar02 from 'Assets/02.png';
import avatar03 from 'Assets/03.png';
import avatar04 from 'Assets/04.png';
import avatar05 from 'Assets/05.png';
import avatar06 from 'Assets/06.png';
import avatar07 from 'Assets/07.png';
import avatar08 from 'Assets/08.png';
import avatar09 from 'Assets/09.png';
import avatar10 from 'Assets/10.png';
import avatar11 from 'Assets/11.png';
import avatar12 from 'Assets/12.png';

export const AVATAR_COLLECTION = [
  avatar11,
  avatar01,
  avatar02,
  avatar03,
  avatar04,
  avatar05,
  avatar06,
  avatar07,
  avatar08,
  avatar09,
  avatar10,
  avatar12,
];

// Fetch a preset avatar asset and return it as a base64 data URL, matching the
// shape the profile-image upload API expects (same as a file upload). Both the
// onboarding screen and Settings apply a preset by converting it this way.
export const presetAvatarToDataUrl = async (src) => {
  const response = await fetch(src);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
